import Vue from 'vue'
import router from './router'
import store from './store/store'
import {sync} from 'vuex-router-sync'
import slick from 'vue-slick'
import scrollTo from 'vue-scrollto'
import gtag from 'vue-gtag'
import axios from 'axios'
import vueAxios from 'vue-axios'

import header from './components/header.vue'
import footer from './components/footer.vue'
import index from './views/index.vue'
import top from './components/top.vue'
import products from './components/products.vue'
import detail from './components/detail.vue'
import article from './components/article.vue'


const URL = process.env.VUE_APP_CMS+'/system/data_output2/'
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$uri = URL
Vue.prototype.$slick = slick
Vue.use(slick,scrollTo,axios,vueAxios)

Vue.use(gtag, {
  config:{ id: process.env.VUE_APP_GA },
},router)

Vue.use(gtag, {
  config:{ id: process.env.VUE_APP_UA },
},router)


sync(store,router)


new Vue({
	router,
	store,
	render: h => h(header)
}).$mount('#header')

new Vue({
	router,
	store,
	scrollTo,
	render: h => h(footer)
}).$mount('#footer')

new Vue({
	router,
	store,
	top,
	products,
	detail,
	article,
	render: h =>h(index)
}).$mount("#index")